import MenuItem, { MenuItemRenderProps } from '../../menu-item';
import { Link } from 'react-router-dom';
import { Category } from '../../../types/catalog';
import { useContext, useEffect } from 'react';
import { CategoriesContext } from '../../../App';

const MenuItemRender = ({
    isOpen,
    hasChildren,
    onOpen,
    isCurrentPath,
    url,
    nameOrig,
    children,
}: MenuItemRenderProps) => (
    <ul className="catalog-section-tree-list">
        <li>
            {hasChildren && (
                <span className="spoiler-control" onClick={onOpen} data-expand={isOpen ? '1' : '0'} />
            )}
            &nbsp;
            <Link
                to={url}
                className={
                    'catalog-section-tree-list__link' +
                    (isCurrentPath ? ' catalog-section-tree-list__link_selected_true' : '')
                }
            >
                {nameOrig}
            </Link>
            {isOpen &&
                children?.map((item) => <MenuItem key={item.slug} {...item} render={MenuItemRender} />)}
        </li>
    </ul>
);
const OniMenuItem = (cat: Category) => {
    // по дефолту открыты первые 2 уровня
    const { fetchCategoryChildren, categorySlugs } = useContext(CategoriesContext);
    useEffect(() => {
        if (!categorySlugs.length && cat.children?.some((c) => !c.children)) {
            fetchCategoryChildren(cat.slugPath);
        }
    }, [categorySlugs.length, cat.children, cat.slugPath, fetchCategoryChildren]);

    return <MenuItem defaultIsOpen {...cat} render={MenuItemRender} />;
};

export default OniMenuItem;
